/**
 * SVG compass 
 */
define('commons/azimuth-selector',['jquery', 'd3js', 'utils/trigo'], function($, d3, trigo) {

    var Compass = function(container, options) {
        this.options= {
            'width' : 500,
            'height' : 500,
            'radius' : 200,
            'lineWidth' : 10,
            'onChangeAzimuth' : undefined,
            'onChangeAttenuationDirect' : undefined,
            'onChangeAttenuationIndirect' : undefined,
            'onChangeAttenuation' : undefined,
        };
        // Extends options
        $.extend(this.options, options);
        this.container = container;
        $(this.container).css( 'width', this.options.width );
        $(this.container).css( 'height', this.options.height );
        $(this.container).css( 'float', 'left' );
        this.drawing = false;
        this.lock = false;
        this.arcs = [];
        this.lineAzimuthId = 'lineAzimuth';
        this.lineAttenuationDirectId = 'lineAttenuationDirect';
        this.lineAttenuationIndirectId = 'lineAttenuationIndirect';
        this.xOrigin = this.options.width / 2;
        this.yOrigin = this.options.height / 2;
        this.xEast = this.xOrigin + this.options.radius;
        this.yEast = this.yOrigin;
        this.draw();
    };

    Compass.prototype.draw = function() {
        var self = this;
        // Init SVG
        this.svg = d3.select(this.container)
                        .insert('svg')
                        .attr('width', this.options.width)
                        .attr('height', this.options.height);
        // Init Arc
        this.arcs.push(d3.svg.arc().innerRadius(1).outerRadius(this.options.radius).startAngle(0).endAngle(2 * Math.PI));
        this.arcs.push(d3.svg.arc().innerRadius(1).outerRadius(this.options.radius).startAngle(0).endAngle(0));
        // Init Gradient
        var gradient = this.svg.append('svg:defs').append('svg:radialGradient').attr('id', 'good-gradient').attr('cx', '50%').attr('cy', '50%');
        gradient.append('stop').attr('offset', '50%').style('stop-color', '#84BF04' ).attr('stop-opacity', '1');
        gradient.append('stop').attr('offset', '100%').style('stop-color', '#7fb501').attr('stop-opacity', '1');
        this.gradient_bad = this.svg.append('svg:defs').append('svg:radialGradient').attr('id', 'bad-gradient').attr('cx', '50%').attr('cy', '50%');
        this.gradient_bad.append('stop').attr('offset', '50%').style('stop-color', 'red' ).attr('stop-opacity', '1');
        this.gradient_bad.append('stop').attr('offset', '100%').style('stop-color', '#d30000').attr('stop-opacity', '1');
        // Draw 2 arcs (good and bad)
        this.goodZone = this.svg.append('path')
                        .attr('d', this.arcs[0])
                        .attr('transform', 'translate('+this.options.width/2+','+this.options.height/2+')')
                        .attr('stroke-width', 2)
                        .attr('stroke', 'gray')
                        .attr('fill', 'url(#good-gradient)');
        this.goodZone.on('mousedown', $.proxy(this.mouseDown(this.goodZone[0][0]), this));
        this.badZone = this.svg.append('path')
                        .attr('d', this.arcs[1])
                        .attr('transform', 'translate('+this.options.width/2+','+this.options.height/2+')')
                        .attr('stroke', 'none')
                        .attr('fill', 'url(#bad-gradient)');
        this.badZone.on('mousedown', $.proxy(this.mouseDown(this.badZone[0][0]), this));
        // Draw ticks and texts
        this.svg.append('circle').attr('r', this.options.radius + 40).attr('cx', this.options.width/2).attr('cy', this.options.height/2).attr('stroke-width', 2).attr('stroke', 'gray').attr('fill', 'none');
        this.svg.append('svg:text').text('N').attr('x', this.options.width / 2 - 10).attr('y', this.options.height / 2 - this.options.radius + 40).style('font-size', '30px');
        this.svg.append('svg:text').text('S').attr('x', this.options.width / 2 - 10).attr('y', this.options.height / 2 + this.options.radius - 20).style('font-size', '30px');
        this.svg.append('svg:text').text('E').attr('x', this.options.width / 2 + this.options.radius - 40).attr('y', this.options.height / 2 + 10).style('font-size', '30px');
        this.svg.append('svg:text').text('W').attr('x', this.options.width / 2 - this.options.radius + 20).attr('y', this.options.height / 2 + 5).style('font-size', '30px');

        var transform = function(data, index) {
            return 'translate(' + ((self.options.radius + 10)*Math.cos(rad) + self.xOrigin) + ',' + ((self.options.radius + 10)*Math.sin(rad) + self.yOrigin ) + ')' + 'rotate(' + i + ')rotate(' + (angle > 180 ? -180 : 0) + ')';
        };
        var textAnchor = function(d) {
            return angle > 180 ? 'end' : 'start';
        };

        for (var i = 0; i < 360; i += 5){
            var bigTick = i%45 === 0;
            var size = (bigTick?0:5);
            if (bigTick){
                var angle = this.rotate(i);
                var rad = angle > 180 ? trigo.toRadians (i-2) : trigo.toRadians (i+2);
                this.svg.append('svg:text')
                    .text( angle + '°' )
                    .attr('transform', transform)
                    .style('font-size', '12px')
                    .attr('text-anchor', textAnchor);
            }
            this.svg.append('line')
                        .attr('x1', Math.cos(trigo.toRadians (i)) * this.options.radius + this.xOrigin)
                        .attr('y1', Math.sin(trigo.toRadians (i)) * this.options.radius + this.yOrigin)
                        .attr('x2', Math.cos(trigo.toRadians (i)) * (this.options.radius + size) + this.xOrigin)
                        .attr('y2', Math.sin(trigo.toRadians (i)) * (this.options.radius + size) + this.yOrigin)
                        .style('stroke', 'grey')
                        .style('stroke-width', '1px');
        }
        // define line marker (start line - circle - and end line - arrow -)
        this.svg.append('svg:defs').append('svg:marker')
            .attr('id', 'start-line')
            .attr('viewBox', '0 0 10 10')
            .attr('refX', 5)
            .attr('refY', 5)
            .attr('markerWidth', 3)
            .attr('markerHeight', 3)
            .attr('orient', 'auto')
            .attr('fill', 'grey')
          .append('circle')
            .attr('r', '5')
            .attr('cx', '5')
            .attr('cy', '5');
        this.svg.append('svg:defs').append('svg:marker')
            .attr('id', 'arrow')
            .attr('viewBox', '0 -5 10 10')
            .attr('refX', 0)
            .attr('markerWidth', 1)
            .attr('markerHeight', 1)
            .attr('orient', 'auto')
            .attr('fill', 'grey')
            .append('svg:path').attr('d', 'M0,-5L10,0L0,5');
        // Create drag action
        this.drag = d3.behavior.drag().on('drag', $.proxy(function(d) {
            if (!self.drawing){
                var mouse = d3.mouse(this);
                var xMouse = mouse[0];
                var yMouse = mouse[1];    
                var angle = trigo.getAngle(xMouse, yMouse, self.xEast, self.yEast, self.xOrigin, self.yOrigin);
                var line = d3.select(this);
                var angleBefore = parseFloat(line.attr('angle')); 
                self.moveToAngle(angle, line);
                if (self.lock && (line.attr('id') == self.lineAttenuationDirectId || line.attr('id') == self.lineAttenuationIndirectId)){
                    // move other attenuation
                    var otherLine = line.attr('id') == self.lineAttenuationDirectId ? self.line_attenuationIndirect : self.line_attenuationDirect;
                    var diff = (angle - angleBefore);
                    angle = parseFloat(otherLine.attr('angle')) + diff;
                    if (!isNaN(angle)){
                        self.moveToAngle(angle, otherLine);
                    }
                }
                
            }
        }), this);
        // Create Azimuth selector
        this.line_azimuth = this.createLine(0, this.lineAzimuthId, true, true);
    };

    Compass.prototype.createLine = function(angle, id, start, end){
        var line = this.svg.append('line')
                            .attr('id', id)
                            .attr('x1', this.options.width/2)
                            .attr('y1', this.options.height/2)
                            .attr('x2', Math.sin(angle) * this.options.radius + this.xOrigin)
                            .attr('y2', -Math.cos(angle) * this.options.radius + this.yOrigin)
                            .attr('stroke-width', this.options.lineWidth)
                            .attr('stroke', 'gray')
                            .call(this.drag);
        if (start){
            line.attr('marker-start', 'url(#start-line)');
        }
        if (end){
            line.attr('marker-end', 'url(#arrow)');
        }
        return line;
    };

    Compass.prototype.rotate = function(degrees){
        return (degrees + 90) % 360;
    };

    Compass.prototype.mouseDown = function(zone){
        return function() {
            if (this.drawing){
                var mouse = d3.mouse(zone);
                var xMouse = mouse[0] + this.options.width/2;
                var yMouse = mouse[1] + this.options.height/2;    
                var angle = trigo.getAngle(xMouse, yMouse, this.xEast, this.yEast, this.xOrigin, this.yOrigin);
                if (this.line_attenuationDirect === undefined){
                    this.line_attenuationDirect = this.createLine(angle, this.lineAttenuationDirectId, false, false);
                    this.moveToAngle(angle, this.line_attenuationDirect);
                } else {
                    if (this.line_attenuationIndirect !== undefined){
                        this.line_attenuationIndirect.remove();
                    }
                    this.line_attenuationIndirect = this.createLine(angle, this.lineAttenuationIndirectId, false, false);
                    this.moveToAngle(angle, this.line_attenuationIndirect);
                }
            }
      };
    };

    Compass.prototype.moveToAngle = function(angle, line){
        line.attr('angle', angle);
        // Set the new position
        line.attr('x2', Math.cos(angle) * this.options.radius + this.xOrigin).attr('y2', Math.sin(angle) * this.options.radius + this.yOrigin);
        // rotate angle
        var degrees = this.rotate(trigo.toDegrees(angle));
        angle +=  (Math.PI/2);
        if (line.attr('id') == this.lineAzimuthId){
            if (this.options.onChangeAzimuth !== undefined) {
                this.options.onChangeAzimuth.call(this, degrees.toFixed(2));
            }
            this.azimuth = angle;
        } else {
            if (line.attr('id') == this.lineAttenuationDirectId){
                if (this.options.onChangeAttenuationDirect !== undefined){
                    this.options.onChangeAttenuationDirect.call(this, degrees.toFixed(2));
                }
                this.attenuationDirect = angle;
            } else if (line.attr('id') == this.lineAttenuationIndirectId){
                if (this.options.onChangeAttenuationIndirect !== undefined){
                    this.options.onChangeAttenuationIndirect.call(this, degrees.toFixed(2));
                }
                this.attenuationIndirect = angle;
            }
            
            this.fillArc();
        }
    };

    Compass.prototype.fillArc = function(){
        if (this.attenuationDirect !== undefined && this.attenuationIndirect !== undefined){
            if (this.attenuationDirect > this.attenuationIndirect){
                this.arcs[0].startAngle(-2*Math.PI + this.attenuationDirect).endAngle(this.attenuationIndirect);
                this.goodZone.attr('d', this.arcs[0]);
                this.arcs[1].startAngle(this.attenuationIndirect).endAngle(this.attenuationDirect);
                this.badZone.attr('d', this.arcs[1]);
            } else {
                this.arcs[0].startAngle(this.attenuationDirect).endAngle(this.attenuationIndirect);
                this.goodZone.attr('d', this.arcs[0]);
                this.arcs[1].startAngle(-2*Math.PI + this.attenuationIndirect).endAngle(this.attenuationDirect);
                this.badZone.attr('d', this.arcs[1]);
            }
        }else{
            this.arcs[0].startAngle(0).endAngle(2*Math.PI);
            this.goodZone.attr('d', this.arcs[0]);
            this.arcs[1].startAngle(0).endAngle(0);
            this.badZone.attr('d', this.arcs[1]);
        }
    };

    Compass.prototype.setAzimuth = function(angle){
        angle = (angle - 90) % 360;
        if (this.line_azimuth === undefined){
            this.line_azimuth = this.createLine(angle, this.lineAzimuthId, true, true);
        }
        this.moveToAngle(trigo.toRadians(angle), this.line_azimuth);
    };

    Compass.prototype.setAttenuationDirect = function(angle){
        angle = (angle - 90) % 360;
        if (this.line_attenuationDirect === undefined){
            this.line_attenuationDirect = this.createLine(angle, this.lineAttenuationDirectId, false, false);
        }
        var angleBefore = parseFloat(this.line_attenuationDirect.attr('angle')); 
        angle = trigo.toRadians(angle);
        this.moveToAngle(angle, this.line_attenuationDirect);
        if (this.lock && this.line_attenuationIndirect !== undefined){
            var diff = (angle - angleBefore);
            angle = parseFloat(this.line_attenuationIndirect.attr('angle')) + diff;
            if (!isNaN(angle)){
                this.moveToAngle(angle, this.line_attenuationIndirect);
            }
        }
    };
    
    
    Compass.prototype.setAttenuationIndirect = function(angle){
        angle = (angle - 90) % 360;
        if (this.line_attenuationIndirect === undefined){
            this.line_attenuationIndirect = this.createLine(angle, this.lineAttenuationIndirectId, false, false);
        }
        var angleBefore = parseFloat(this.line_attenuationIndirect.attr('angle')); 
        angle = trigo.toRadians(angle);
        this.moveToAngle(angle, this.line_attenuationIndirect);
        if (this.lock && this.line_attenuationDirect !== undefined){
            var diff = (angle - angleBefore);
            angle = parseFloat(this.line_attenuationDirect.attr('angle')) + diff;
            if (!isNaN(angle)){
                this.moveToAngle(angle, this.line_attenuationDirect);
            }
        }
    };

    Compass.prototype.setAttenuation = function(attenuation){
        this.attenuation = attenuation;
        this.gradient_bad.selectAll('stop').attr('stop-opacity', parseInt(attenuation)/100);
    };

    Compass.prototype.clearAttenuation = function(){
        if (this.line_attenuationDirect !== undefined) {
            this.line_attenuationDirect.remove();
            this.line_attenuationDirect = undefined;
        }
        if (this.line_attenuationIndirect !== undefined) {
            this.line_attenuationIndirect.remove();
            this.line_attenuationIndirect = undefined;
        }
        this.attenuationDirect = undefined;
        this.attenuationIndirect = undefined;
        this.setAttenuation(0);
        if (this.options.onChangeAttenuationDirect !== undefined){
            this.options.onChangeAttenuationDirect('');
        }
        if (this.options.onChangeAttenuationIndirect !== undefined){
            this.options.onChangeAttenuationIndirect('');
        }
        if (this.options.onChangeAttenuation !== undefined){
            this.options.onChangeAttenuation('');
        }
        this.fillArc();
    };

    Compass.prototype.setDrawingMode = function(draw){
        this.drawing = draw;
    };

    Compass.prototype.setLock = function(locked){
        this.lock = locked;
    };

    return Compass;
});

